import { FunctionalComponent, h } from '@stencil/core';

export type InputVariant = 'outlined' | 'borderless';

interface InputProps {
  label?: string;
  identifier?: string;
  withAsterisk?: boolean;
  error?: boolean;
  boldInput?: boolean;
  autocomplete: 'on' | 'off';
  placeholder?: string;
  name?: string;
  inputRef?: (elm?: HTMLInputElement) => void;
  onKeyDown?: (event: KeyboardEvent) => void;
  onBlur?: (event: FocusEvent) => void;
  onKeyUp?: (event: KeyboardEvent) => void;
  onClick?: (event: MouseEvent) => void;
  onInput?: (event: InputEvent) => void;
  disabled?: boolean;
  value: string | number | string[];
  helperText?: string;
  ariaLabel?: string;
  inputType?: string;
  variant?: InputVariant;
  maxlength?: number;
}

export const Input: FunctionalComponent<InputProps> = ({
  label,
  identifier,
  withAsterisk,
  error,
  boldInput,
  autocomplete,
  placeholder,
  name,
  inputRef,
  disabled,
  inputType,
  value,
  onKeyDown,
  onKeyUp,
  onClick,
  helperText,
  ariaLabel,
  onInput,
  onBlur,
  variant = 'outlined',
  maxlength,
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div class={{ input: true }} onClick={onClick}>
      {label && (
        <label class="input__label" htmlFor={identifier}>
          {label} {withAsterisk && <span>*</span>}
        </label>
      )}
      <input
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        class={{
          'input-element': true,
          [`input-element__${variant}`]: true,
          'input-element--error': error,
          'input-element--bold': boldInput,
        }}
        part="input"
        autoComplete={autocomplete}
        placeholder={placeholder}
        id={identifier}
        name={name}
        ref={inputRef}
        type={inputType}
        disabled={disabled}
        value={value}
        onBlur={onBlur}
        aria-label={ariaLabel}
        onInput={onInput}
        maxlength={maxlength}
        aria-describedby="pp-input-error-message"
        // eslint-disable-next-line jsx-a11y/aria-proptypes
        aria-invalid={`${helperText ? 'true' : 'false'}`}
      ></input>
      {helperText && (
        <span
          class={{ 'input__helper-text': true, 'input__helper-text--error': error }}
          innerHTML={helperText}
          id="pp-input-error-message"
          aria-live="polite"
        ></span>
      )}
    </div>
  );
};
